// src/app/koleksiyonUrl.ts
//
// KOLEKSİYON DETAYI URL ŞEMASI — TEK KAYNAK (SAF).
//
// 🩺 Kapatılan kusur (kanonun kalıcı URL kuralı): `components/Collections/`
// altında TEK BİR `pushState`/`replaceState` yoktu ve detay yüzeyi hiç
// yoktu (`onOpenCollection={() => {}}` — iki çağrı yerinde de boş). Yani
// kullanıcı "Milas'ın en iyi kahvaltıcıları" listesini yapıyor ama KİMSEYE
// GÖNDEREMİYORDU; yenileyince de kayboluyordu.
//
// ŞEMA: `/u/{ownerParam}/collections/{collectionId}`
//   - `/u/{param}` tabanı BİLEREK seçildi: router yorumunun yazdığı gibi o
//     param "kullanıcı adı VEYA ham uid" olabilir (V3 feed adres çubuğuna
//     `/u/<uid>` yazıyor). Koleksiyonlar `collections/{ownerUid}/items/{id}`
//     altında UID ile anahtarlı → yazıcı UID yazar, okuyucu ikisini de kabul
//     eder (kullanıcı adı gelirse `usernames/{ad}` ile uid'ye çevrilir).
//   - Çıplak `/{kullaniciAdi}/collections/{id}` biçimi AÇILMADI: çıplak
//     matcher'ın alt-yol alternasyonu `profilSekmeUrl.test.ts` tarafından
//     dize olarak taranıyor ve o alternasyona yeni bir dal eklemek kart
//     detayının (`cards/{kod}`) yanına ikinci bir özel-durum koymak olurdu.
//     `/u/` tabanı zaten rezerve ve çakışmasız.

const KOLEKSIYON_DESENI = /^\/u\/([^/]+)\/collections\/([A-Za-z0-9_.-]+)\/?$/;

export type KoleksiyonHedefi = { ownerParam: string; collectionId: string };

/** Hedef → canonical yol. Eksik alan → null (uydurma yol üretilmez). */
export function koleksiyonYolu(
  ownerParam: string | null | undefined,
  collectionId: string | null | undefined,
): string | null {
  const o = String(ownerParam || "").trim();
  const c = String(collectionId || "").trim();
  if (!o || !c) return null;
  return `/u/${encodeURIComponent(o)}/collections/${encodeURIComponent(c)}`;
}

/** Yol → hedef (soğuk yük). Trailing-slash toleranslı. */
export function yoldanKoleksiyon(
  path: string | null | undefined,
): KoleksiyonHedefi | null {
  const m = String(path || "").match(KOLEKSIYON_DESENI);
  if (!m) return null;
  const coz = (s: string) => {
    try {
      return decodeURIComponent(s);
    } catch {
      return s;
    }
  };
  const ownerParam = coz(m[1]).trim();
  const collectionId = coz(m[2]).trim();
  if (!ownerParam || !collectionId) return null;
  return { ownerParam, collectionId };
}

/** Şu an bir koleksiyon detayı yolunda mıyız? (kapanış/popstate kararı) */
export function koleksiyonYolundaMi(path: string | null | undefined): boolean {
  return yoldanKoleksiyon(path) !== null;
}
